import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

const RootLine = ({ className = "", light = false }) => {
  const stroke = light ? "rgba(248,246,239,0.35)" : "rgba(75,93,52,0.35)";
  const draw = (d, delay = 0, dur = 2.2) => (
    <motion.path
      d={d}
      fill="none"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      initial={{ pathLength: 0 }}
      whileInView={{ pathLength: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: dur, delay, ease: EASE }}
    />
  );
  return (
    <svg
      viewBox="0 0 1200 140"
      className={`w-full ${className}`}
      aria-hidden="true"
      preserveAspectRatio="none"
    >
      {draw("M0 70 C 180 30, 320 110, 500 70 S 860 30, 1040 75 S 1180 60, 1200 70")}
      {draw("M500 70 C 520 100, 560 118, 610 128", 0.9, 1.4)}
      {draw("M760 58 C 780 88, 830 110, 890 122", 1.2, 1.4)}
      {draw("M260 82 C 240 106, 200 120, 160 126", 1.4, 1.4)}
    </svg>
  );
};

export default RootLine;
